import { createTranslationMessages } from '@backstage/frontend-plugin-api';
import { TranslationBlueprint } from '@backstage/plugin-app-react';
import { searchReactTranslationRef } from '@backstage/plugin-search-react/alpha';

export const searchReactTranslation = TranslationBlueprint.make({
  name: 'search-react',
  params: {
    resource: createTranslationMessages({
      ref: searchReactTranslationRef,
      full: false,
      messages: {
        'searchBar.title': 'Zoek',
        'searchBar.placeholder': 'Zoek in {{org}}',
        'searchBar.clearButtonTitle': 'Wis',
        'searchFilter.allOptionTitle': 'Alle',
        'searchPagination.limitLabel': 'Resultaten per pagina:',
        'searchPagination.limitText': 'van {{num}}',
        noResultsDescription: 'Er zijn geen resultaten gevonden',
        'searchResultGroup.linkTitle': 'Alles bekijken',
        'searchResultGroup.addFilterButtonTitle': 'Voeg filter toe',
        'searchResultPager.previous': 'Vorige',
        'searchResultPager.next': 'Volgende',
      },
    }),
  },
});
